var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-basic',[_c('v-container',[_c('activity-widget',{attrs:{"total_courses":_vm.total_courses,"total_in_progress_courses":_vm.total_in_progress_courses,"total_completed_courses":_vm.total_completed_courses}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }